import app from 'flarum/forum/app';
import ArenaBattleTurnPost from './components/ArenaBattleTurnPost';
import ArenaBattleStartPost from './components/ArenaBattleStartPost';
import ArenaBattleOpenPost from './components/ArenaBattleOpenPost';
import ArenaBattleWaitPost from './components/ArenaBattleWaitPost';
import ArenaBattleNextTurnPost from './components/ArenaBattleNextTurnPost';
import ArenaBattleSurrenderPost from './components/ArenaBattleSurrenderPost';
import ArenaBattleExpiredPost from './components/ArenaBattleExpiredPost';
import ArenaBattleDrawPost from './components/ArenaBattleDrawPost';
import ArenaBattleAdminClosedPost from './components/ArenaBattleAdminClosedPost';
import ArenaBattleClosedPost from './components/ArenaBattleClosedPost';
export default function addPostTypes() {
  app.postComponents.arenaBattleTurn = ArenaBattleTurnPost;
  app.postComponents.arenaBattleStart = ArenaBattleStartPost;
  app.postComponents.arenaBattleOpen = ArenaBattleOpenPost;
  app.postComponents.arenaBattleWait = ArenaBattleWaitPost;
  app.postComponents.arenaBattleNext = ArenaBattleNextTurnPost;
  app.postComponents.arenaBattleSurrender = ArenaBattleSurrenderPost;
  app.postComponents.arenaBattleExpired = ArenaBattleExpiredPost;
  app.postComponents.arenaBattleDraw = ArenaBattleDrawPost;
  app.postComponents.arenaBattleAdminClosed = ArenaBattleAdminClosedPost;
  app.postComponents.arenaBattleClosed = ArenaBattleClosedPost;
}